import { render, staticRenderFns } from "./FloatingSidebar.vue?vue&type=template&id=4134abfc&scoped=true"
import script from "./FloatingSidebar.vue?vue&type=script&lang=js"
export * from "./FloatingSidebar.vue?vue&type=script&lang=js"
import style0 from "./FloatingSidebar.vue?vue&type=style&index=0&id=4134abfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4134abfc",
  null
  
)

export default component.exports